import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { ILayoutStore } from '../../store/LayoutStore'
import { IUserStore } from '../../store/UserStore'
import Card from '../Card/Card'
import Drawer from '../Drawer/Drawer'
import EditResponse from '../EditResponse/EditResponse'
import ValidateButton from '../ValidateButton/ValidateButton'
import { IStepState } from '../Step/Step'
// Import image
import imageStepSexMan from '../../assets/img/StepSexMan.jpg'
import imageStepSexWoman from '../../assets/img/StepSexWoman.jpg'
import { tag } from '../../services/ATInternetService'
import IddleMessage from '../IddleMessage/IddleMessage'

export interface IStepSexState {
  selectedValue: string
}

interface IStepSexProps {
  LayoutStore?: ILayoutStore
  UserStore?: IUserStore
  stepState: IStepState
  onChange: (change: object) => void
  onResetAnswer: () => void
}

@inject('UserStore', 'LayoutStore')
@observer
class StepSex extends React.Component<IStepSexProps, IStepSexState> {
  public constructor(props: IStepSexProps) {
    super(props)
    this.state = {
      selectedValue: this.props.UserStore!.gender,
    }

    if (this.state.selectedValue !== null) {
      this.props.onChange({ needValidation: true })
    }
  }

  public render() {
    return (
      <fieldset>
        <div className="Row Row--mw500">
          <legend>Pour commencer, faisons un peu connaissance : Vous êtes ..?</legend>
        </div>
        {this.props.stepState.isAnswered && (
          <>
            <div className="Row Row--center">
              {this.props.UserStore!.gender === 'F' ? (
                <Card image={imageStepSexWoman} label="Une femme" variant="response" />
              ) : (
                <Card image={imageStepSexMan} label="Un homme" variant="response" />
              )}

              <EditResponse functionEdit={this.props.onResetAnswer} />
            </div>
          </>
        )}
        {!this.props.stepState.isAnswered && (
          <Drawer>
            <React.Fragment>
              <Card name="femme" label="Une femme" image={imageStepSexWoman}>
                <input
                  className="visuallyHidden"
                  id="femme"
                  type="radio"
                  value="F"
                  name="sex"
                  checked={this.state.selectedValue === 'F'}
                  onChange={this.validateSelection}
                />
              </Card>

              <Card name="homme" label="Un homme" image={imageStepSexMan}>
                <input
                  className="visuallyHidden"
                  id="homme"
                  type="radio"
                  value="H"
                  name="sex"
                  checked={this.state.selectedValue === 'H'}
                  onChange={this.validateSelection}
                />
              </Card>
            </React.Fragment>
          </Drawer>
        )}

        {!this.props.stepState.isAnswered && this.props.stepState.needValidation && (
          <div className="control-color-wrapper">
            <ValidateButton onClick={this.setGender} />
          </div>
        )}

        {!this.props.stepState.isAnswered && !this.props.stepState.needValidation && (
          <div className="control-color-wrapper">
            <IddleMessage iddleMessageLabel="Choisissez une réponse" />
          </div>
        )}
      </fieldset>
    )
  }

  private validateSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ selectedValue: e.target.value })
    this.props.onChange({ needValidation: true })
  }

  private setGender = () => {
    tag.sendPage({ elem: this, name: 'sexe_ok', chapter1: 'Questionnaire' })
    this.props.UserStore!.setGender(this.state.selectedValue)
    this.props.onChange({ isAnswered: true, needValidation: false })
  }
}

export default StepSex



// WEBPACK FOOTER //
// ./src/components/StepSex/StepSex.tsx